"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetail = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const TextField_1 = __importDefault(require("../FormFields/TextField"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const QuantityPicker_1 = __importDefault(require("./QuantityPicker"));
const ProductDetailWrapper = styled_components_1.default.div `
    height: 100%;
    background: #fff;
    font-size: 1rem;

    .description{
      margin-bottom: 30px;
    }
`;
const Title = styled_components_1.default.div `
    font-size: 1.5rem;
`;
const CommentWrapper = styled_components_1.default.div `
    position: relative;
`;
const CharacterCount = styled_components_1.default.div `
    position: absolute;
    bottom: 21px;
    right: 14px;
    color: rgba(0, 0, 0, 0.6);
`;
const QuantityWrapper = styled_components_1.default.div `
    display: flex;
`;
const Total = styled_components_1.default.div `
    flex-basis: 50%;
`;
const Buttons = styled_components_1.default.div `
    flex-basis: 50%;
    text-align: right;
    display: flex;
    justify-content: flex-end;
`;
const AddToBasketButton = styled_components_1.default.div `
    text-align: right;
    button {
        text-transform: initial;
        color: ${props => (props.theme.palette ? props.theme.palette.mainAppColor.main : "#000")};
        border-color: ${props => (props.theme.palette ? props.theme.palette.mainAppColor.main : "#000")};

        &:hover {
            border-color: ${props => (props.theme.palette ? props.theme.palette.mainAppColor.main : "#000")};
        }
    }
`;
const ProductContent = styled_components_1.default.div `
    padding-bottom: 20px;
`;
const ProductDetail = (props) => {
    const { data, hideProduct, currentLocale, userData, shoppingCartCatalogId, addToBasket, } = props;
    const { id } = data;
    const [comment, setComment] = (0, react_1.useState)("");
    const [quantity, setQuantity] = (0, react_1.useState)(1);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [commentCharCount, setCommentCharCount] = (0, react_1.useState)(0);
    const [orderData, setOrderData] = (0, react_1.useState)(null);
    const handleAddToBasket = (event) => {
        event.preventDefault();
        setIsLoading(true);
        const order = `&order[line_items][][comment]=${comment}&order[line_items][][product_id]=${id}&order[line_items][][quantity]=${quantity}`;
        apiService_1.default.reviewShoppingCartOrder(currentLocale, userData.token, shoppingCartCatalogId, order).then((orderReview) => {
            if (orderReview.status === "success") {
                addToBasket(orderReview.order.lineItems);
                hideProduct(true);
            }
            else {
                setIsLoading(false);
            }
        });
    };
    const handleCommentChange = () => (event) => {
        setComment(event.target.value);
        setCommentCharCount(event.target.value.length);
    };
    const handleQuantityChange = (product, newQuantity) => {
        if (newQuantity > 0) {
            setQuantity(newQuantity);
        }
    };
    const renderAddToBasketButton = () => {
        if (!orderData) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return (react_1.default.createElement(AddToBasketButton, null,
            react_1.default.createElement(material_1.Button, { onClick: handleAddToBasket, variant: "outlined", disabled: isLoading }, orderData.texts.addToCartButton)));
    };
    (0, react_1.useEffect)(() => {
        const order = `&order[line_items][][comment]=${comment}&order[line_items][][product_id]=${id}&order[line_items][][quantity]=${quantity}`;
        setIsLoading(true);
        apiService_1.default.reviewShoppingCartOrder(currentLocale, userData.token, shoppingCartCatalogId, order).then((orderReview) => {
            setOrderData(orderReview);
            setIsLoading(false);
        });
    }, [quantity]);
    return (react_1.default.createElement(ProductDetailWrapper, { "data-testid": "product-detail-wrapper", className: "product-detail" },
        react_1.default.createElement(ProductContent, null,
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(Title, null, data.name)),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement("div", { className: "description" }, data.description)),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(QuantityWrapper, null,
                        react_1.default.createElement(Total, null, orderData === null || orderData === void 0 ? void 0 : orderData.texts.addToCartButton.split(/[()]/)[1]),
                        react_1.default.createElement(Buttons, null,
                            react_1.default.createElement(QuantityPicker_1.default, { item: data, onChange: handleQuantityChange })))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(CommentWrapper, null,
                        react_1.default.createElement(TextField_1.default, { fieldData: { label: i18n_js_1.default.t("shopping_cart_catalog_line_item_comment_default"), value: comment }, onChange: handleCommentChange, textarea: true, maxLength: "100" }),
                        react_1.default.createElement(CharacterCount, null,
                            commentCharCount,
                            "/100"))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, renderAddToBasketButton())))));
};
exports.ProductDetail = ProductDetail;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.ProductDetail);
